import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
// import { Skeleton } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Card } from 'react-bootstrap';

function AnalyticsBox({ selectedReport, reportObj }) {
    const ReportComponent = reportObj[selectedReport];
    return (
        <Suspense
            fallback={
                <Card>
                    <Skeleton count={20}>Loading...</Skeleton>
                </Card>
            }
        >
            <ReportComponent />
        </Suspense>
    );
}

export default AnalyticsBox;

AnalyticsBox.propTypes = {
    selectedReport: PropTypes.string.isRequired,
    reportObj: PropTypes.object.isRequired,
};
